import { ReactNode } from 'react'
import styled from 'styled-components'
import Collapsible from './Collapsible'
import Icons from './Icons'
import { interactiveBackgroundHover } from './mixins/interactive'
import Text from './Text'

const InteractiveFlex = styled(Flex)`
  border-radius: ${(p) => p.theme.radiuses.sm}px;
  gap: ${(p) => p.theme.spacings.sm}px;
  padding: ${(p) => p.theme.spacings.sm}px;

  justify-content: space-between;
  align-items: center;

  ${interactiveBackgroundHover};
`

interface CollapsibleSectionProps {
  title: ReactNode
  badge?: ReactNode
  isOpen: boolean
  onToggle: () => void
  children: ReactNode
}

const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  title,
  badge,
  isOpen,
  onToggle,
  children
}) => {
  return (
    <Flex $flexDirection='column' $gap='md'>
      <InteractiveFlex onClick={onToggle}>
        <Flex $alignItems='center' $gap='sm' $flex={1}>
          {typeof title === 'string' ? <Text $fontWeight='bold'>{title}</Text> : title}
          {badge}
        </Flex>
        {isOpen ? <Icons.Fold $size='lg' /> : <Icons.Unfold $size='lg' />}
      </InteractiveFlex>
      <Collapsible isOpen={isOpen} direction='vertical'>
        {children}
      </Collapsible>
    </Flex>
  )
}

export default CollapsibleSection
